import Container from '@/components/base/Container'
import LoadMoreButton, {
  LoadMoreProps as LoadMoreButtonProps
} from '@/components/base/LoadMore'

import { Section } from '@/types'

type LoadMoreProps = Section & Pick<LoadMoreButtonProps, 'fetching'>

const LoadMore = ({ fetching, ...props }: LoadMoreProps) => {
  return (
    <section {...props}>
      <Container>
        <LoadMoreButton fetching={fetching} />
      </Container>
    </section>
  )
}

export default LoadMore
